import { QueryKey, queryOptions } from '@tanstack/react-query'

import { CHARGING_POINT_QUERY_KEYS } from './keys'
import { GetChargingPointPayload } from './types'
import { getChargingPoint } from './services'

const ONE_MINUTE = 60 * 1000

export const createChargingPointQueryOptions = (params: GetChargingPointPayload) => {
  const queryKey: QueryKey = [CHARGING_POINT_QUERY_KEYS.GET_CHARGING_POINT, params]
  const queryFn = () => getChargingPoint(params)

  return queryOptions({
    queryKey,
    queryFn,
    refetchInterval: ONE_MINUTE,
  })
}
